import { SystemSlotEvent } from '@mbrtargeting/metatag-shared-types/metatag-core';
import { createIntersectionObservable, getBrowserDetails, getViewportDimensions, once } from '@mbrtargeting/metatag-utils';
import { triggerEvent } from '../../loader/essentials/events.js';
import { logger } from '../../loader/essentials/logger.js';
import { Adslot } from '../modules/adslot-controller/adslot.js';
import { eventBus$ } from '../observables/event-bus.js';
import { EffectFunction } from './index.js';

const log = logger.logGroup({ prefix: 'LazyLoad Effect' });

interface ObserverConfig {
    observerName: string;
    options: IntersectionObserverInit;
}

const createObserverConfig = (): ObserverConfig => {
    const { isTablet, isPhone } = getBrowserDetails();
    const { viewportHeight } = getViewportDimensions();
    if (isTablet) return { observerName: 'tablet', options: { rootMargin: `${Math.max(150, .25 * viewportHeight)}px 0px` } };
    if (isPhone) return { observerName: 'phone', options: { rootMargin: `${Math.max(150, .25 * viewportHeight)}px 0px` } };
    return { observerName: 'desktop', options: { rootMargin: '200px 0px' } };
}

export const LAZYLOAD_SLOT: EffectFunction = (adslot: Adslot) => {

    const ac = new AbortController();
    const { observerName, options } = createObserverConfig();

    const sendLazyLoadEventOnce = once(observerName => {
        log.debug(`lazyLoad done event triggered from observer ${observerName} on the Slot ${adslot.slotName}`);
        triggerEvent(SystemSlotEvent.SDG_SLOT_LAZY_LOAD_READY, {
            passedObject: adslot,
            placement: adslot,
            slot: adslot.slotName,
            position: adslot.slotName,
            slotName: adslot.slotName,
        });
        eventBus$.next({ type: SystemSlotEvent.SDG_SLOT_LAZY_LOAD_READY, slotId: adslot.slotId, slotName: adslot.slotName });
        ac.abort();
    });

    createIntersectionObservable(adslot.containerNode, options)
        .subscribe(({ isIntersecting }) => isIntersecting && sendLazyLoadEventOnce(observerName), ac);

    return () => {
        ac.abort();
    };
};
